import React from 'react';
import { Send } from 'lucide-react';

interface YesNoButtonsProps {
    onResponse: (response: string) => void;
    t: (t: string) => string
}

const YesNoButtons: React.FC<YesNoButtonsProps> = ({ onResponse, t }) => {
    return (
        <div className="flex justify-end items-center gap-2 mt-3 pt-2 border-t border-gray-100">
            <button
                className="flex items-center gap-1 px-4 py-1.5 rounded-full transition-all duration-200 bg-blue-50 hover:bg-blue-100 text-blue-600"
                aria-label="Yes"
                onClick={() => onResponse(t('words.yes'))}
            >
                <span className="text-sm font-medium">{t('words.yes')}</span>
            </button>
            <button
                className="flex items-center gap-1 px-4 py-1.5 rounded-full transition-all duration-200 bg-red-50 hover:bg-red-100 text-red-500"
                aria-label="No"
                onClick={() => onResponse(t('words.no'))}

            >
                <span className="text-sm font-medium">{t('words.no')}</span>
            </button>
        </div>
    );
};

export default YesNoButtons;